# Deep links a LOGGED-OUT visitor is allowed to land on directly.
#
# Both institutional app bootstraps (TeacherPortal and Organization) blank the
# hash when nobody is signed in, on the reasonable assumption that a stale route
# is meaningless to a visitor who is about to see the sign-in screen. The
# password-reset link breaks that assumption: its entire audience is people who
# cannot sign in, arriving cold from an email, and the token lives in the hash.
# Wiping it there destroyed the link before UI-Router ever ran.
#
# Card 6a639e22893d0bbbaaacec81. Keep this list tiny — anything added here is a
# route reachable with no session at all, so it must be safe unauthenticated.

UNAUTHENTICATED_ROUTES = ['/reset']

# Accepts the raw window.location.hash ('#/reset?token=...'), tolerating the
# '#/' and bare '#' forms, and matches on the PATH only so a query string
# cannot smuggle a different route past the check.
export isUnauthenticatedDeepLink = (hash) ->
  return false unless hash
  path = "#{hash}".replace(/^#/, '').split('?')[0].replace(/\/$/, '')
  path in UNAUTHENTICATED_ROUTES

export default isUnauthenticatedDeepLink
